<template>
    <div class="profile-about-blocks d-flex">

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{user.actual_pets_count || 0}}</span>
                актуальных <br> подопечных
            </div>

        </div>

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{user.total_pets_count || 0}}</span>
                всего <br> животных
            </div>

        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{user.adopted_pets_count || 0}}</span> пристроено
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{ user.actual_projects_count || 0 }}</span> проектов
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">
                    {{+user['donated_by_user']}} BYN
                </span>

                средств <br> отправлено
            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: "UserAbout",
    props: ['user']
}
</script>

<style scoped>

</style>
